// extracted by mini-css-extract-plugin
module.exports = {"terms":"pc_terms__jG_xT","main":"pc_main__q0k3Z"};